import * as types from './actionType';

export const fetchValueChainData = () => ({
    type: types.VALUE_CHAIN_DATA_REQUESTED,
    data: null
})
export const fetchValueChainOverviewData = () => ({
    type: types.VALUE_CHAIN_OVERVIEW_REQUESTED,
    data: null
})